<div
  class="scan-code-box d-flex justify-content-center mt-5 align-items-center">
  <p-card header="Scan the QR Code to download the Mobile APP">
    <div class="qr-container">
      <div class="qr-code">
        <a (click)="redirectToSalesAppPage()"
          ><img [src]="qrCodeUrl" alt="QR Code"
        /></a>
      </div>
    </div>
  </p-card>
</div>
